import { whiteColor, shadowColor, lightBlue, lightgray } from 'theme/color';

export const vendorCard = {
  background: whiteColor,
  boxShadow: 'none',
  // border: "1px solid rgba(17, 35, 71, 0.1)",
  border: ' 0.5px solid #E4E4E4',
  borderRadius: '5px',
  padding: '20px',
  marginBottom: '30px',
  marginTop: '30px',
  width: '100%',
};

export const vendorTop = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px',
  justifyContent: 'space-between',
};
export const listview = {
  fontFamily: 'poppins',
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #F0F0F0',
  borderRadius: '5px',
  height: '41px',
  justifyContent: 'center',
  flexShrink: 0,
  p: '5px',
  cursor: 'pointer',
};
